import { ErrorClusterGroupRow } from "./index";

export function truncateLabel(label: string, maxLength: number = 30): string {
  if (label.length <= maxLength) {
    return label;
  }
  return label.substring(0, maxLength - 3) + "...";
}

export function transformToBarChartData(data: ErrorClusterGroupRow[]) {
  // Group by errorPattern and sum up facilitiesInGroupCount
  const patternMap = new Map<string, number>();

  for (const row of data) {
    const existing = patternMap.get(row.errorPattern);
    if (existing) {
      patternMap.set(row.errorPattern, existing + row.facilitiesInGroupCount);
    } else {
      patternMap.set(row.errorPattern, row.facilitiesInGroupCount);
    }
  }

  // Convert to array, sort by count descending, take top 5
  const topPatterns = Array.from(patternMap.entries())
    .map(([errorPattern, totalCount]) => ({
      errorPattern,
      totalCount,
    }))
    .sort((a, b) => b.totalCount - a.totalCount)
    .slice(0, 5);

  const categories = topPatterns.map((p) => truncateLabel(p.errorPattern));
  const values = topPatterns.map((p) => p.totalCount);
  const fullCategories = topPatterns.map((p) => p.errorPattern);

  return { categories, values, fullCategories };
}
